module.exports = __webpack_public_path__ + "img/1-trust.b6135432.svg";